var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76165 0.492132C7.62114 0.191385 7.3242 0 6.9981 0C6.67199 0 6.37771 0.191385 6.23454 0.492132L4.5298 4.10931L0.722631 4.68893C0.404484 4.73814 0.139361 4.9678 0.041265 5.28222C-0.0568306 5.59664 0.0227063 5.94387 0.250712 6.17626L3.0133 8.99509L2.36109 12.9786C2.30807 13.3067 2.44063 13.6403 2.7031 13.8344C2.96557 14.0285 3.31288 14.0531 3.59922 13.8973L7.00075 12.0244L10.4023 13.8973C10.6886 14.0531 11.0359 14.0312 11.2984 13.8344C11.5609 13.6375 11.6934 13.3067 11.6404 12.9786L10.9855 8.99509L13.7481 6.17626C13.9761 5.94387 14.0583 5.59664 13.9576 5.28222C13.8568 4.9678 13.5944 4.73814 13.2762 4.68893L9.46639 4.10931L7.76165 0.492132Z",
    fill: "url(#paint0_linear_213_23241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_23241",
    x1: 0,
    y1: 0,
    x2: 14.6364,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9242FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183008,
    stopColor: "#797EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#69A3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#5BBEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43EAB2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.c4877b49b751ca02b1564c78f1c75ebf.svg";
export { ForwardRef as ReactComponent };